export const productSeriesConf: Record<string, { productId: string; variantId: string }[]> = {
    ph: [
        {
            productId: '10394908557622',
            variantId: '53215190188342',
        },
        {
            productId: '10394908557622',
            variantId: '53215190221110',
        },
    ],
};
